import { createAction, props } from '@ngrx/store';

import { OrbiHistoryConversation } from '@patient-ui/shared/models';

import { OrbiError } from '../orbi/orbi-error';

/**
 * Conversation-history actions (PCSA-13169). Trigger / success / failure
 * convention (see `orbi.actions.ts`). The list is paginated with skip/take and
 * lives only while the history view is open; rename/delete mutate it in place.
 */

/** Load the first page (reset) — dispatched when the history view opens. */
export const loadOrbiHistory = createAction('[Orbi History] Load');

/** Load the next page (append) — the "load more" / infinite-scroll trigger. */
export const loadMoreOrbiHistory = createAction('[Orbi History] Load More');

export const loadOrbiHistorySuccess = createAction(
  '[Orbi History] Load Success',
  // `reset` distinguishes a first-page load (replace) from a page append.
  // `reachedEnd` is inferred client-side (fewer than `take` returned) — the
  // backend exposes no total/hasMore (mirrors mobile).
  props<{
    conversations: OrbiHistoryConversation[];
    reset: boolean;
    reachedEnd: boolean;
  }>()
);

export const loadOrbiHistoryFailure = createAction(
  '[Orbi History] Load Failure',
  props<{ error: OrbiError }>()
);

/** Rename a conversation (PATCH /history/{sessionId}). */
export const renameOrbiConversation = createAction(
  '[Orbi History] Rename',
  props<{ sessionId: string; title: string }>()
);

export const renameOrbiConversationSuccess = createAction(
  '[Orbi History] Rename Success',
  props<{ sessionId: string; title: string }>()
);

export const renameOrbiConversationFailure = createAction(
  '[Orbi History] Rename Failure',
  props<{ error: OrbiError }>()
);

/** Soft-delete a conversation (DELETE /history/{sessionId}). */
export const deleteOrbiConversation = createAction(
  '[Orbi History] Delete',
  props<{ sessionId: string }>()
);

export const deleteOrbiConversationSuccess = createAction(
  '[Orbi History] Delete Success',
  props<{ sessionId: string }>()
);

export const deleteOrbiConversationFailure = createAction(
  '[Orbi History] Delete Failure',
  props<{ error: OrbiError }>()
);

export const OrbiHistoryActions = {
  loadOrbiHistory,
  loadMoreOrbiHistory,
  loadOrbiHistorySuccess,
  loadOrbiHistoryFailure,
  renameOrbiConversation,
  renameOrbiConversationSuccess,
  renameOrbiConversationFailure,
  deleteOrbiConversation,
  deleteOrbiConversationSuccess,
  deleteOrbiConversationFailure,
};
